import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainKO() {
  const articleData = {
    title: '왜 어떤 사람들은 우리를 지치게 합니까? (AI가 설명합니다)',
    description: '텍스트로 인해 감정적으로 지치셨나요? Toxic Detector의 AI가 관계에서 일방적인 의사 소통과 미묘한 감정적 소모 패턴을 감지하는 방법을 알아보세요.',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Toxic Detector 편집팀'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '관계에서의 감정적 소모란 무엇입니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '감정적 소모는 누군가와의 상호 작용으로 인해 지속적으로 피곤하거나 좌절하거나 죄책감을 느낄 때 발생하며, 종종 일방적이거나 조작적인 의사 소통으로 인해 발생합니다.'
      }
    }, {
      '@type': 'Question',
      name: '문자 메시지가 어떻게 감정적 소모를 유발할 수 있습니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '반복되는 일방적인 메시지, 죄책감 유발, 일관성 없는 참여 또는 미묘한 비판은 큰 갈등 없이도 당신을 지치게 할 수 있습니다.'
      }
    }, {
      '@type': 'Question',
      name: 'AI가 누가 내 감정적 에너지를 고갈시키는지 감지할 수 있습니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네. Toxic Detector는 텍스트 패턴, 어조 및 참여를 분석하여 일방적, 조작적 또는 소모적인 행동을 즉시 강조합니다.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/ko/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };
  return <>
      <MetaTags title="왜 어떤 사람들은 우리를 지치게 합니까? — AI가 설명하는 감정적 소모 | ToxicDetector" description="텍스트로 인해 감정적으로 지치셨나요? Toxic Detector의 AI가 일방적인 의사 소통과 미묘한 감정적 소모 패턴을 감지하는 방법을 알아보세요." keywords="관계에서의 감정적 소모, 일방적인 텍스트 패턴, 에너지 뱀파이어, AI 감정 분석" canonical={`https://toxicdetector.com/ko/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-8288" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-8289">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-8290">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8291">
            <div className="flex items-center justify-between" data-id="element-8292">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-8293">
                <span className="text-2xl" data-id="element-8294">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-8295">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-8296">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-8297">
                  무료 스캔
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="기사 공유" data-id="element-8298">
                  <Share2 size={20} className="text-gray-600" data-id="element-8299" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-8300">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-8301">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8302" />
            홈으로 돌아가기
          </Link>

          <header className="mb-16" data-id="element-8303">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-8304">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-8305">
              <time dateTime={articleData.publishDate} data-id="element-8306">
                {new Date(articleData.publishDate).toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8307">•</span>
              <span data-id="element-8308">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-8309">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="AI가 문자 메시지의 감정적 소모 패턴 분석" className="w-full rounded-2xl shadow-lg" data-id="element-8310" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-8311">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-8312">목차</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-8313">
              <li data-id="element-8314">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8315">
                  "항상 뭔가 잘못된" 친구
                </a>
              </li>
              <li data-id="element-8316">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8317">
                  필요할 때만 문자하는 사람
                </a>
              </li>
              <li data-id="element-8318">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8319">
                  감정 없는 "단답형"
                </a>
              </li>
              <li data-id="element-8320">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8321">
                  잠수 & 복귀 아티스트
                </a>
              </li>
              <li data-id="element-8322">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8323">
                  미묘한 죄책감 유발자
                </a>
              </li>
              <li data-id="element-8324">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8325">
                  가짜 지지자
                </a>
              </li>
              <li data-id="element-8326">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8327">
                  "건강-유독" 콤보
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-8328">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-8329">
              누군가에게 문자를 보내고 대화가 싸움이 아니었음에도 불구하고
              나중에 피곤하거나 짜증나거나 이상하게 죄책감을 느낀 적이 있나요?
              그것은{' '}
              <strong className="text-gray-900" data-id="element-8330">관계에서의 감정적 소모</strong>
              이며, 생각보다 흔합니다.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-8331">
              그것은 <strong className="text-gray-900" data-id="element-8332">일방적인 문자</strong>{' '}
              패턴과 미묘한 조작입니다. 저희{' '}
              <strong className="text-gray-900" data-id="element-8333">AI 분석</strong>은 이러한 패턴을
              즉시 읽습니다.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-8334">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8335">
                1️⃣ "항상 뭔가 잘못된" 친구
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8336">
                휴대폰을 확인하고 즉시 느낍니다:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8337">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8338">
                  "오 맙소사... 이번엔 또 뭐야?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8339">
                모든 메시지는 스트레스, 혼란 또는 불만입니다. AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8340">일방적인 감정적 부하</strong>
                로 표시합니다.
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-8341">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8342">
                2️⃣ 필요할 때만 문자하는 사람
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8343">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8344">
                  <strong className="text-gray-900" data-id="element-8345">절대:</strong> "잘 지내?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-8346">
                  <strong className="text-gray-900" data-id="element-8347">항상:</strong> "...해줄 수
                  있어?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8348">
                AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8349">거래적 의사 소통</strong>으로
                감지합니다.
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-8350">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8351">
                3️⃣ 감정 없는 "단답형"
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8352">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8353">
                  "응."
                  <br data-id="element-8354" />
                  "ㅇㅇ."
                  <br data-id="element-8355" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8356">
                AI는 이러한 <strong className="text-gray-900" data-id="element-8357">단절 신호</strong>
                를 즉시 포착합니다.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-8358">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8359">
                4️⃣ 잠수 & 복귀 아티스트
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8360">
                3주 동안 사라집니다. 다음과 같이 돌아옵니다:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8361">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8362">
                  "안녀엉 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8363">
                AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8364">일관성 없는 참여</strong>로
                표시합니다.
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-8365">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8366">
                5️⃣ 미묘한 죄책감 유발자
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8367">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8368">
                  "그럼 나 혼자 갈게..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8369">
                AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8370">수동적 조작</strong>으로
                표시합니다.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-8371">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8372">
                6️⃣ 가짜 지지자
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8373">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8374">
                  "내 말은, 네가 가끔 과민 반응하는 경향이 있다는 거야."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8375">
                AI는 <strong className="text-gray-900" data-id="element-8376">가면을 쓴 비판</strong>을
                감지합니다.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-8377">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8378">
                7️⃣ "건강-유독" 콤보
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8379">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8380">
                  어떤 날은 따뜻함. 어떤 날은 차가움.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8381">
                AI는 이 패턴을{' '}
                <strong className="text-gray-900" data-id="element-8382">불안정한 감정 리듬</strong>
                으로 표시합니다.
              </p>
            </section>

            <section className="mb-16" data-id="element-8383">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8384">
                이것이 중요한 이유
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-8385">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-8386">
                  패턴을 보면 다음을 할 수 있습니다:
                </p>
                <ul className="space-y-5" data-id="element-8387">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8388">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8389">
                      ✓
                    </span>
                    <span data-id="element-8390">에너지 보호</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8391">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8392">
                      ✓
                    </span>
                    <span data-id="element-8393">경계 설정</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8394">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8395">
                      ✓
                    </span>
                    <span data-id="element-8396">죄책감 느끼지 않기</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-8397">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-8398">
                자주 묻는 질문
              </h2>
              <div className="space-y-5" data-id="element-8399">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-8400">
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-8401">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-8402">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-8403">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-8404">
              😮‍💨 지친 기분은 그만.
              <br data-id="element-8405" />
              명확하게 보기 시작하세요.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-8406">
              추측은 그만하세요. 텍스트를 Toxic Detector에 업로드하고 즉시 독성
              점수를 받으세요.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-8407">
              <p className="font-bold text-2xl" data-id="element-8408">
                "⚠️ 감정적 소모: 높음. 일방적인 의사 소통 감지됨."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-8409">
              지금 채팅 스캔하기 →
            </Link>
          </div>

          <div className="mt-20" data-id="element-8410">
            <RelatedBlogPosts posts={[{
            title: '왜 어떤 사람들은 우리를 지치게 합니까? 2부',
            description: '과도한 설명과 잘난 체하는 사람을 포함하여 에너지를 고갈시키는 더 미묘한 패턴.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: '수동적 공격적인 텍스트에 대한 궁극적인 가이드',
            description: '문자 메시지에서 수동적 공격적인 행동과 숨겨진 조작을 발견하세요.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-8411" />
          </div>

          <div className="mt-16 text-center" data-id="element-8412">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-8413">
              <Share2 size={20} data-id="element-8414" />이 기사 공유하기
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-8415">
          <div className="max-w-4xl mx-auto px-6" data-id="element-8416">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-8417">
              <p className="text-gray-400 text-sm" data-id="element-8418">
                © {new Date().getFullYear()} ToxicDetector. 판권 소유.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}